var $ = jQuery;
$(document).ready(function ($) {
    // Mobile Menu Functionality
    const menuTrigger = $('.menu-trigger');
    const mobileMenu = $('.mobile-menu');
    const closeMenuBtn = $('.mobile-menu-close');
    
    // Open mobile menu
    menuTrigger.on('click', function() {
        mobileMenu.addClass('active');
        $('body').addClass('menu-open');
    });
    
    // Close mobile menu
    closeMenuBtn.on('click', function() {
        mobileMenu.removeClass('active');
        $('body').removeClass('menu-open');
    });
    
    // Close mobile menu on resize if window width is >= 768px
    $(window).on('resize', function() {
        if ($(window).width() >= 768 && mobileMenu.hasClass('active')) {
            mobileMenu.removeClass('active');
            $('body').removeClass('menu-open');
        }
    });
    
    // Close mobile menu when clicking outside
    $(document).on('click', function(e) {
        if (
            mobileMenu.hasClass('active') && 
            !$(e.target).closest('.mobile-menu-container').length && 
            !$(e.target).closest('.menu-trigger').length
        ) {
            mobileMenu.removeClass('active');
            $('body').removeClass('menu-open');
        }
    });
    
    // Document scroll events
    $(document).on('scroll', function() {
        // Add your scroll-related functionality here
    });
    
    // Recipe Grid Filter functionality
    initRecipeGridFilter();
    
    // Disable logo animations after they run once
    setTimeout(function() {
        // Get all logo images
        const logoImages = document.querySelectorAll('.logo-wrapper img, .mobile-logo img');
        
        // Remove animations from all logo images
        logoImages.forEach(function(img) {
            img.style.animation = 'none';
            img.style.opacity = '1'; // Ensure it remains visible
        });
    }, 2000); // Wait 2 seconds to ensure animations have completed
});

// Initialize Recipe Grid Filter functionality
function initRecipeGridFilter() {
    const filterOptions = document.querySelectorAll('.filter-option');
    const recipeGrids = document.querySelectorAll('.blk-recipes-grid');
    const categoryFilter = document.querySelector('.category-filter');
    
    if (!filterOptions.length || !recipeGrids.length) {
        return; // Exit if elements don't exist
    }
    
    // Mark all recipe grids as visible initially
    recipeGrids.forEach(grid => {
        grid.classList.add('visible');
    });
    
    // Add a class to body to indicate JS is initialized
    document.body.classList.add('js-initialized');
    
    // Mobile scroll for filter options
    if (window.innerWidth <= 768 && categoryFilter) {
        // Add scroll indicators if needed
        categoryFilter.classList.add('scrollable');
        
        // Scroll active item into view
        const activeOption = document.querySelector('.filter-option.active');
        if (activeOption) {
            setTimeout(() => {
                activeOption.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }, 100);
        }
    }
    
    // Handle filter option click
    filterOptions.forEach(option => {
        option.addEventListener('click', function() {
            const selectedCategory = this.dataset.category;
            
            // Update active state on filter options
            filterOptions.forEach(btn => {
                btn.classList.remove('active');
            });
            this.classList.add('active');
            
            // Scroll the selected filter into view on mobile
            if (window.innerWidth <= 768) {
                this.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
            
            // Show/hide recipe grids based on selection
            if (selectedCategory === 'all') {
                // Show all recipe grids with animation
                recipeGrids.forEach(grid => {
                    grid.style.display = 'block';
                    setTimeout(() => {
                        grid.classList.add('visible');
                    }, 50);
                });
            } else {
                // First hide all grids
                recipeGrids.forEach(grid => {
                    if (!grid.classList.contains('recipes-grid-' + selectedCategory)) {
                        grid.classList.remove('visible');
                        setTimeout(() => {
                            grid.style.display = 'none';
                        }, 300); // Match transition duration
                    }
                });
                
                // Then show only those matching the selected category
                const matchingGrids = document.querySelectorAll('.recipes-grid-' + selectedCategory);
                matchingGrids.forEach(grid => {
                    grid.style.display = 'block';
                    setTimeout(() => {
                        grid.classList.add('visible');
                    }, 50);
                });
            }
            
            // Calculate scroll position to keep filter title 150px from top
            setTimeout(() => {
                const filterTitle = document.querySelector('.filter-title');
                const targetGrid = document.querySelector('.recipes-grid-' + selectedCategory) || recipeGrids[0];
                
                if (filterTitle && targetGrid) {
                    // Get the position of the filter title
                    const filterTitleRect = filterTitle.getBoundingClientRect();
                    const currentScroll = window.pageYOffset;
                    
                    // Calculate the desired position with different offsets based on screen size
                    const scrollOffset = window.innerWidth <= 992 ? 90 : 120;
                    const desiredPosition = currentScroll + filterTitleRect.top - scrollOffset;
                    
                    // Scroll to the calculated position
                    window.scrollTo({
                        top: desiredPosition,
                        behavior: 'smooth'
                    });
                }
            }, 350);
        });
    });
}

$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});